import { useState } from "react";
import { HeaderItem } from "../../../../../types/menu";
import { Link, useLocation, useNavigate } from "react-router-dom";

interface Props { 
  item: HeaderItem, 
  setIsNavOpen: (truth: boolean) => void 
}

const MobileHeaderLink: React.FC<Props> = ({ item, setIsNavOpen }) => {

  const location = useLocation();
  const navigate = useNavigate();


  return (
    <div className="relative w-full">
      <Link
        to={item.href}
        onClick={ e => {
          e.preventDefault()
          navigate(item.href)
          setIsNavOpen(false)
        }}
        className={`flex items-center justify-between w-full py-2 ${ location.pathname === item.href ? 'text-primary' : 'text-muted'} focus:outline-none`}
      >
        {item.label}
        {item.submenu && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1.5em"
            height="1.5em"
            viewBox="0 0 24 24"
          >
            <path
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="m7 10l5 5l5-5"
            />
          </svg>
        )}
      </Link>
    </div>
  );
};

export default MobileHeaderLink;
